import React, { createContext, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './assets/style/App.scss';
import Navbar from './components/Navbar';
import { UserProvider } from './providers/UserProvider';
import AppRoutes from './routes/AppRoutes';
import { createTheme, ThemeProvider } from '@mui/material';

export const LogoutMessageContext = createContext();

function App() {
  const [themeColor, setThemeColor] = useState('#1f4d79');
  const theme = createTheme({
    palette: {
      primary: {
        main: '#3179B6',
      },
      outlinedLight: {
        main: '#0000001F',
      },
    },
  });

  // const [message, setMessage] = useState({ text: null, type: null });

  // const handleLogoutMessage = (message, token) => {
  //   if (message.code != null) {
  //     switch (message.code) {
  //       case 401:
  //         message = {
  //           text: FRONTEND_ERRORS.F4013,
  //           type: "error",
  //         };
  //         break;
  //       default:
  //         message = {
  //           text: FRONTEND_ERRORS.F0001,
  //           type: "error",
  //         };
  //     }
  //   }

  //   if (token != null && jwt_decode(token)?.exp * 1000 < new Date().getTime()) {
  //     setMessage({
  //       text: NL_FRONTEND_ERROR_MESSAGES.get(FRONTEND_ERRORS.F4011),
  //       type: "error",
  //     });
  //   } else if (message.type === "error") {
  //     setMessage({
  //       text: NL_FRONTEND_ERROR_MESSAGES.get(message.text) ?? message.text,
  //       type: "error",
  //     });
  //   } else {
  //     setMessage({
  //       text: NL_FRONTEND_MESSAGES.get(message.text) ?? message.text,
  //       type: "success",
  //     });
  //   }
  // };

  return (
    <ThemeProvider theme={theme}>
      <UserProvider>
        <Router>
          <Navbar themeColor={themeColor} setThemeColor={setThemeColor}>
            <AppRoutes themeColor={themeColor} setThemeColor={setThemeColor} />
          </Navbar>
        </Router>
      </UserProvider>
    </ThemeProvider>
  );
}

export default App;
